<div class="flex flex-col border-b border-gray-400 bg-white py-2">
  <div appStickyContent [scrollContainerId]="scrollContainerId">
    <div
      *ngIf="!loading; else titleLoadingPlaceholder"
      class="flex w-full flex-row items-center justify-between gap-y-2 bg-white py-1 lg:flex-wrap-reverse lg:items-center"
      [ngClass]="{
        'flex-col-reverse lg:flex-row': detailHeaderData?.previousItem || detailHeaderData?.nextItem
      }">
      <div class="flex w-full flex-col flex-wrap items-start gap-2 lg:w-auto lg:flex-row lg:items-center">
        <p-tag
          *ngIf="detailHeaderData?.reference"
          class="ml-4"
          styleClass="h-8"
          [value]="detailHeaderData?.reference"></p-tag>
        <app-inplace
          (resetValue)="titleValue = detailHeaderData?.title"
          [disabled]="!editable"
          (setValue)="updateTitleValue()">
          <ng-template #viewMode>
            <h1 class="m-0">{{ detailHeaderData?.title }}</h1>
          </ng-template>
          <ng-template #editMode>
            <input pInputText [size]="titleValue?.length" class="h1 h-auto" [(ngModel)]="titleValue" />
          </ng-template>
        </app-inplace>
      </div>
      <div class="mx-4 flex gap-2">
        <button
          *ngIf="hasHistory"
          pButton
          [title]="'eventlog.title' | translate"
          icon="fa-regular fa-clock-rotate-left"
          class="p-button-outlined p-button-sm p-button-icon-only w-8"
          [routerLink]="['ROUTES.history'] | localize"></button>
        <ng-container *ngTemplateOutlet="extraOptionsContentTpl"></ng-container>
      </div>
    </div>
  </div>
  <div
    class="flex flex-col gap-2 bg-white"
    appStickyContent
    [scrollContainerId]="scrollContainerId"
    [stickyOnlySelectors]="['.sticky-element']">
    <div
      *ngIf="!loading; else statusLoadingPlaceholder"
      class="flex flex-wrap items-center justify-between gap-4 bg-white px-4">
      <div class="flex flex-wrap items-center gap-2">
        <div class="sticky-element">
          <p-tag
            *ngIf="detailHeaderData?.status"
            [style]="{
              background: detailHeaderData?.status?.color
            }"
            [title]="detailHeaderData?.status?.name | translate"
            styleClass="overflow-hidden whitespace-nowrap h-8">
            <div class="flex items-center gap-2 overflow-hidden">
              <span
                [style]="{
                  color: (detailHeaderData?.status?.color | lightenDarkenColor) + ' !important'
                }"
                class="overflow-hidden text-ellipsis whitespace-nowrap"
                >{{ detailHeaderData?.status?.shortName }}</span
              >
              <i
                *ngIf="detailHeaderData?.status?.icon as statusIcon"
                [class]="statusIcon"
                [style]="{
                  color: (detailHeaderData?.status?.color | lightenDarkenColor) + ' !important'
                }"></i>
            </div>
          </p-tag>
        </div>
        <p-tag
          *ngIf="detailHeaderData?.confidential || detailHeaderData?.confidential === false"
          styleClass="border border-gray-500 bg-gray-100 text-gray-700 h-8"
          [ngClass]="{
            'cursor-pointer hover:bg-gray-300': editable
          }"
          [icon]="confidentiality?.icon"
          (click)="editable && openConfidentialityDialog()"
          [title]="confidentiality?.label | translate">
          {{ confidentiality?.label | translate }}
        </p-tag>
        <div
          *ngIf="detailHeaderData?.creator"
          class="flex items-center text-sm text-gray-800"
          [title]="detailHeaderData?.creator">
          <i class="fa-regular fa-user mr-1"></i>
          <div>{{ detailHeaderData?.creator }}</div>
        </div>
        <div
          *ngIf="detailHeaderData?.date"
          class="sticky-element text-gray-700"
          [title]="detailHeaderData?.date | date: 'd MMMM yyyy HH:mm'">
          <i class="fa-regular fa-calendar mr-1 text-gray-600"></i
          >{{ detailHeaderData?.date | date: 'd MMMM yyyy HH:mm' }}
        </div>
      </div>
      <button
        *ngIf="hasDetailData"
        pButton
        type="button"
        class="p-button-link"
        [icon]="infoVisible ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"
        [label]="infoVisible ? ('common.label.less' | translate) : ('common.label.more' | translate)"
        (click)="infoVisible = !infoVisible"></button>
    </div>
    <div
      *ngIf="infoVisible && !loading && hasDetailData"
      class="mx-4 flex flex-col gap-2 rounded-lg bg-gray-100 p-4 text-sm text-gray-800">
      <app-detail-header-info
        *ngIf="detailHeaderData?.location"
        [title]="'common.field.location' | translate"
        [description]="detailHeaderData?.location"
        [disabled]="!editable"
        [editable]="editable">
      </app-detail-header-info>
      <app-detail-header-info
        *ngIf="detailHeaderData?.type"
        [title]="'common.field.type' | translate"
        [description]="detailHeaderData?.type"
        [disabled]="!editable"
        [editable]="editable">
      </app-detail-header-info>
      <app-detail-header-info
        *ngIf="detailHeaderData?.meetingType"
        [title]="'calendar.add.type' | translate"
        [description]="detailHeaderData?.meetingType"
        [disabled]="!editable"
        [editable]="editable">
      </app-detail-header-info>
      <app-detail-header-info
        *ngIf="detailHeaderData?.publicRef"
        [title]="'common.field.publicref' | translate"
        [description]="detailHeaderData?.publicRef"
        [disabled]="!editable"
        [editable]="editable">
      </app-detail-header-info>
      <app-detail-header-info
        *ngIf="detailHeaderData?.description || editable"
        [title]="'common.field.description' | translate"
        [description]="descriptionValue"
        [disabled]="!editable"
        [editable]="editable"
        (setDescriptionValue)="updateDescriptionValue($event)">
      </app-detail-header-info>
    </div>
    <div *ngIf="infoVisible && loading" class="px-4">
      <p-skeleton height="5rem"></p-skeleton>
    </div>
  </div>
  <div appStickyContent [scrollContainerId]="scrollContainerId">
    <div *ngIf="!loading; else actionbarContentPlaceholder" class="bg-white px-4">
      <ng-container *ngTemplateOutlet="actionbarContentTpl"></ng-container>
    </div>
  </div>
</div>

<ng-template #titleLoadingPlaceholder>
  <div class="flex w-full flex-wrap gap-2 px-4 py-2">
    <p-skeleton height="2rem" class="w-full sm:flex-1"></p-skeleton>
    <p-skeleton height="2rem" class="w-full sm:flex-1"></p-skeleton>
  </div>
</ng-template>

<ng-template #statusLoadingPlaceholder>
  <div class="flex w-full flex-wrap gap-2 px-4">
    <p-skeleton height="2rem" class="w-full sm:flex-1"></p-skeleton>
    <p-skeleton height="2rem" class="w-full sm:flex-1"></p-skeleton>
    <p-skeleton height="2rem" class="w-full sm:flex-1"></p-skeleton>
    <p-skeleton height="2rem" class="w-full sm:flex-1"></p-skeleton>
  </div>
</ng-template>

<ng-template #actionbarContentPlaceholder>
  <div class="flex w-full flex-wrap gap-2 px-4 py-2">
    <p-skeleton height="2rem" class="w-full sm:flex-1"></p-skeleton>
  </div>
</ng-template>

<p-dialog
  [(visible)]="confidentialityDialogOpen"
  [header]="'detail.confidentiality.label' | translate"
  [style]="{ width: '450px' }"
  [draggable]="false"
  [resizable]="false"
  [modal]="true"
  contentStyleClass="overflow-visible">
  <ng-template pTemplate="content">
    <div class="flex flex-col gap-2">
      <label htmlFor="confidentiality" class="required">{{ 'detail.confidentiality.label' | translate }}</label>
      <div *ngFor="let option of confidentialityOptions | keyvalue">
        <p-radioButton
          [id]="option.key"
          [inputId]="option.key"
          [value]="option.key"
          [(ngModel)]="confidentialityValue"
          (onClick)="handleChangeConfidentiality($event)"></p-radioButton>
        <label class="ml-2" [for]="option.key">{{ option.value.label | translate }}</label>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex justify-start">
      <button
        type="button"
        pButton
        label="{{ 'common.button.edit' | translate }}"
        (click)="updateConfidentiality()"></button>
      <button
        type="button"
        pButton
        label="{{ 'common.button.cancel' | translate }}"
        class="p-button-outlined"
        (click)="resetConfidentiality()"></button>
    </div>
  </ng-template>
</p-dialog>
